<template>
  <a-modal :visible="visible" title="线下打款" @cancel="$emit('cancel')" width="720px" :footer="null" :zIndex="2000">
    <div class="content">
      <a-alert message="温馨提示：请确保打款公司和签约主体公司保持一致" type="error" />
      <ul class="plat">
        <li>
          <span>收款账户：</span>
          <a-select
            @change="handleChangeAccount"
            class="select"
            :value="account.bankAccount"
            :dropdownStyle="{ zIndex: 10000 }"
          >
            <a-select-option v-for="(item, index) in list" :key="index" :value="item.bankAccount">
              {{ item.accountName }}
            </a-select-option>
          </a-select>
          <a-select @change="handleChangeCurrency" class="select" :value="currency" :dropdownStyle="{ zIndex: 10000 }">
            <a-select-option v-for="(item, index) in currencyList" :key="index" :value="item.currency">
              {{ item.currencyLabel }}
            </a-select-option>
          </a-select>
        </li>
        <li class="amount">
          <span>应付金额：</span>
          <div>{{ payInfo.currencySymbol }}{{ payInfo.amount }}</div>
        </li>
        <li class="foreign">
          <span>币种/金额：</span>
          <div>
            <strong>{{ currencyList.find(c => c.currency === currency) && currencyList.find(c => c.currency === currency).currencySymbol }}</strong>
            <a-input-number class="input" v-model="currencyPayAmount" :min="0" />
          </div>
        </li>
      </ul>
      <div class="account-info">
        <div>账户名称：{{ account.accountName }}</div>
        <div>银行账号：{{ account.bankAccount }}</div>
        <div>银行号：{{ account.bankNo }}</div>
        <div>分行代码：{{ account.branchCode }}</div>
        <div>SWIFT code：{{ account.bankCode }}</div>
        <div>银行名称(Bank Name)：{{ account.bankName }}</div>
        <div>银行地址：{{ account.accountOpeningLocation }}</div>
        <div>公司地址：{{ account.companyContactAddress }}</div>
      </div>
      <a-upload-dragger
        name="file"
        :action="uploadUrl"
        accept="image/png,image/jpeg,image/jpg"
        :file-list="fileList"
        :before-upload="beforeUploadHandler"
        @change="handleChangeUpload"
      >
        <p class="ant-upload-drag-icon"><a-icon type="inbox" /></p>
        <p class="ant-upload-text">点击上传凭证</p>
        <p class="ant-upload-hint">
          请选择对应的支付账户进行线下打款，打款成功后请上传凭证截图，预计1-3个工作日审核完成。<br />
          只能上传jpg/png格式文件，文件不能超过10MB
        </p>
      </a-upload-dragger>
      <div class="footer">
        <a-button type="primary" @click="submit" :loading="payLoading">提交</a-button>
        <a-button @click="$emit('cancel')">取消</a-button>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { rateCalculateAmount } from '../../../api/shoppingCar';
import { uploadCertificate } from '../../../api/payment';
import { getEnterpriseBankAccount } from '../../../api/common';
export default {
  props: {
    payInfo: {
      type: Object,
    },
    visible: {
      type: Boolean,
    },
  },
  data() {
    return {
      // 支付平台信息列表
      list: [],
      currencyList: [
        {
          currency: 'USD',
          currencySymbol: '$',
          currencyLabel: '美元',
        },
        {
          currency: 'HKD',
          currencySymbol: 'HK$',
          currencyLabel: '港币',
        },
        {
          currency: 'CNY',
          currencySymbol: '¥',
          currencyLabel: '人民币',
        },
        {
          currency: 'GBP',
          currencySymbol: '￡',
          currencyLabel: '英镑',
        },
        {
          currency: 'EUR',
          currencySymbol: '€',
          currencyLabel: '欧元',
        },
        {
          currency: 'JPY',
          currencySymbol: 'Ұ',
          currencyLabel: '日元',
        },
      ],
      payLoading: false,
      currencyPayAmount: '',
      fileList: [],
      foreign: {},
      account: {},
      currency: 'USD',
    };
  },
  watch: {
    payInfo: {
      handler(newVal) {
        if (newVal.paymentFile) {
          this.fileList = [
            {
              uid: '1',
              name: newVal.paymentFile
                .split('\\')
                .pop()
                .split('/')
                .pop(),
              status: 'done',
              url: newVal.paymentFile,
            },
          ];
          this.currency = newVal.currency;
          this.currencyPayAmount = newVal.currencyPayAmount;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    if (this.currencyList.find((item) => item.currency === this.payInfo.currency)) {
      this.currency = this.payInfo.currency;
    }
    this.handleCalculate(this.currency);
    getEnterpriseBankAccount({
      accountName: 'HONG KONG CHUANGJIE TONG TECHNOLOGY CO., LIMITED',
    }).then((res) => {
      this.list = res.data.records;
      this.account = res.data.records[0];
    });
  },
  computed: {
    enterpriseid() {
      return (localStorage.getItem('objInfo') && JSON.parse(localStorage.getItem('objInfo')).enterpriseId) || void 0;
    },
  },
  methods: {
    // 改变平台
    handleChangeAccount(val) {
      this.account = this.list.find((item) => item.bankAccount === val);
    },
    // 改变币种
    handleChangeCurrency(val) {
      this.currency = val;
      this.handleCalculate(val);
    },
    // 计算金额
    handleCalculate(currency) {
      rateCalculateAmount({
        afterCurrency: currency,
        amount: this.payInfo.amount,
        beforeCurrency: 'CNY',
        enterpriseId: this.enterpriseid,
      }).then((res) => {
        if (res.code === 0) {
          this.foreign = res.data;
        }
      });
    },
    // 上传前
    beforeUploadHandler(file) {
      let suffix = file.name.split('.')[1];
      if (!['jpg', 'png', 'jpeg'].includes(suffix)) {
        this.$message.error(`文件格式错误，请上传jpg,jpeg,png格式的文件`);
        this.uploadStatus = false;
        return false;
      }
      if (file.size > 10 * 1000 * 1000) {
        this.$message.error(`文件大小不能超过10MB`);
        this.uploadStatus = false;
        return false;
      }
      this.uploadStatus = true;
      this.fileList = [];
    },
    // 上传
    handleChangeUpload(info) {
      if (!this.uploadStatus) {
        return;
      }
      this.payLoading = true;
      let fileList = [...info.fileList];
      fileList = fileList.slice(-2);
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.data.fileUrl;
        }
        return file;
      });
      this.fileList = fileList;
      const status = info.file.status;
      if (status === 'done') {
        this.payLoading = false;
        this.$message.success(`${info.file.name} 上传成功`);
      } else if (status === 'error') {
        this.payLoading = false;
        this.$message.error(`${info.file.name} 上传失败`);
      }
    },
    // 提交
    submit() {
      if (!this.currencyPayAmount) {
        this.$message.warning(`请输入金额`);
        return;
      }
      if (!this.fileList.length || !(this.fileList[0] && this.fileList[0].url)) {
        this.$message.warning(`请上传支付凭证`);
        return;
      }
      const { accountName, bankAccount, bankCode } = this.account;
      const { orderId, amount } = this.payInfo;
      const currencyItem = this.currencyList.find((item) => item.currency === this.currency);
      this.payLoading = true;
      uploadCertificate({
        acceptAccountName: accountName,
        acceptAccountNo: bankAccount,
        currency: currencyItem.currency,
        currencySymbol: currencyItem.currencySymbol,
        swiftCode: bankCode,
        paymentAmount: amount,
        currencyPayAmount: this.currencyPayAmount,
        orderId,
        paymentChannel: this.paymentChannel,
        paymentFile: this.fileList[0].url,
      })
        .then((res) => {
          if (res.code === 0) {
            this.$message.success(`支付凭证提交成功`);
            this.$emit('ok');
          }
        })
        .finally(() => {
          this.payLoading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  .plat {
    margin: 16px 0;
    padding: 16px;
    background: #e3f1ff;
    font-size: 14px;
    li {
      display: flex;
      align-items: center;
      span {
        width: 86px;
      }
    }
    li.foreign {
      div {
        display: flex;
        align-items: center;
        .input {
          width: 146px;
        }
        strong {
          margin-right: 5px;
        }
      }
    }
    li.amount {
      padding: 10px 0;
    }
    .select {
      width: 160px;
      margin-right: 8px;
    }
  }
  .account-info {
    line-height: 26px;
    margin-bottom: 8px;
    background: #eee;
    padding: 10px;
  }
  .ant-upload.ant-upload-drag p.ant-upload-drag-icon {
    margin-bottom: 5px;
  }
  .ant-upload.ant-upload-drag p.ant-upload-text,
  .ant-upload.ant-upload-drag p.ant-upload-hint {
    font-size: 12px;
  }
}
.footer {
  margin-top: 20px;
  text-align: right;
  .ant-btn {
    margin-left: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// xcloud-client-components-web/module/components/intlOfflinePay/index.vue